
import * as z from "zod";

// Form schema with validation
export const companyFormSchema = z.object({
  companyName: z.string().min(1, "Nome da empresa é obrigatório"),
  document: z.string().regex(/^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/, {
    message: "CNPJ deve estar no formato XX.XXX.XXX/XXXX-XX",
  }).or(z.string().length(0)),
  website: z.string().url("URL do website inválida").optional().or(z.string().length(0)),
  phone: z.string().regex(/^\(\d{2}\) \d{5}\-\d{4}$/, {
    message: "Telefone deve estar no formato (XX) XXXXX-XXXX",
  }).or(z.string().length(0)),
  address: z.string().optional(),
});

export type CompanyFormValues = z.infer<typeof companyFormSchema>;
